import React from 'react'
import "./Posts.css";
import {Avatar} from "@material-ui/core";
import Post from "./Post"

function Posts() {
    return (
        <div className="posts">
            
            <div className="post1">
            <Post profilePic="pic1.png" image="profile2.png" title="Taran"/>
                </div>

                <div className="post2">
                <Post profilePic="pic2.png" image="profile1.png" title="Chris"/>
                </div>

                <div className="post3">
                <Post profilePic="pic3.png" image="pic2.png" title="Adam"/>
                </div>
        </div>
    )
}

export default Posts
